import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "../api";
import { DataTable } from "../components/DataTable";
import { DetailDrawer } from "../components/DetailDrawer";
import { PageHeader } from "../components/PageHeader";
import type { DataRecord } from "../types";

export function ModelsPage() {
  const [models, setModels] = useState<DataRecord[]>([]);
  const [selected, setSelected] = useState<DataRecord | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await apiRequest<{ data: DataRecord[] }>("/api/ai-router/models");
      setModels(Array.isArray(response.data) ? response.data : []);
    } catch (failure) {
      setError(failure instanceof Error ? failure.message : "Could not load models");
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { void load(); }, [load]);

  return <>
    <PageHeader title="Models" description="Models currently backed by configured AI Router credentials." onRefresh={() => void load()} refreshing={loading} />
    {error ? <div className="error-banner">{error}</div> : null}
    <section className="data-surface">
      {loading && models.length === 0 ? <div className="loading-state">Loading models…</div> : <DataTable rows={models.map((model) => ({ ...model, price: pricingSummary(model.pricing) }))} columns={[{ key: "id", label: "Model" }, { key: "owned_by", label: "Provider" }, { key: "capability", label: "Type" }, { key: "price", label: "Price" }]} rowKey={(row) => String(row.id)} onInspect={(row) => setSelected(models.find((model) => model.id === row.id) ?? row)} />}
    </section>
    <DetailDrawer title="Model" value={selected} onClose={() => setSelected(null)} />
  </>;
}

function pricingSummary(value: unknown): string {
  return typeof value === "object" && value !== null && "summary" in value && typeof value.summary === "string"
    ? value.summary
    : "Unavailable";
}
